export const mutations = {
  AUTH_MESSAGE_MUTATION({  state, params }) {
    state.message = params;
  },
};
